import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: string;
  title: string;
  category: string;
  year: number;
  rating: number;
  image: string;
  tags: string[];
  updateEpisode: string;
  isHot?: boolean;
  isNew?: boolean;
  isVip?: boolean;
}

export default function MovieCard({
  id,
  title,
  year,
  rating,
  image,
  tags,
  updateEpisode,
  isHot,
  isNew,
}: MovieCardProps) {
  return (
    <Link
      to={`/category/${getCategorySlugFromId(id)}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />

        {(isHot || isNew) && (
          <div className="absolute top-2 left-2 flex gap-1.5">
            {isHot && (
              <span className="px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-white whitespace-nowrap">
                热门
              </span>
            )}
            {isNew && (
              <span className="px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-white whitespace-nowrap">
                上新
              </span>
            )}
          </div>
        )}

        <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/70 rounded px-1.5 py-0.5">
          <span className="text-accent-500 text-xs font-bold">{rating}</span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-white text-sm font-medium leading-tight line-clamp-1">
            {title}
          </h3>
          <div className="flex items-center justify-between mt-1.5">
            <div className="flex items-center gap-1 flex-wrap">
              {tags.slice(0, 2).map((tag) => (
                <span
                  key={tag}
                  className="text-[10px] text-background-300 bg-white/15 rounded px-1.5 py-0.5 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
            <span className="text-[10px] text-background-300 whitespace-nowrap">
              {year}
            </span>
          </div>
          <div className="mt-2 text-[11px] text-accent-400 font-medium whitespace-nowrap">
            {updateEpisode}
          </div>
        </div>
      </div>
    </Link>
  );
}

function getCategorySlugFromId(id: string): string {
  if (id.startsWith('movie-')) return 'movie';
  if (id.startsWith('tv-')) return 'tv';
  if (id.startsWith('anime-')) return 'anime';
  if (id.startsWith('variety-')) return 'variety';
  if (id.startsWith('doc-')) return 'documentary';
  return 'movie';
}